export const theme = {
  colors: {
    // Primary blues from the Miramar logo
    primary: '#005BA9',        // Deep blue from logo
    primaryLight: '#0070C9',   // Lighter blue
    primaryDark: '#004080',    // Darker blue
    
    // Secondary grays from logo
    secondary: '#6D6E71',      // Gray from "PAIN MEDICINE" text
    secondaryLight: '#8B8C8F',
    secondaryDark: '#4A4B4D',
    
    // Accent from the figure
    accent: '#E8F4F8',         // Very light blue accent
    accentDark: '#B8D8E8',
    
    // Backgrounds
    background: '#FFFFFF',
    backgroundAlt: '#F8FAFB',
    
    // Text colors
    text: '#1A1A1A',
    textLight: '#4A4B4D',
    textMuted: '#6D6E71',
    
    // Borders
    border: '#E0E5E8',
    borderLight: '#EDF1F3',
    
    // Status colors
    success: '#28A745',
    error: '#DC3545',
    warning: '#FFC107',
  },
  
  fonts: {
    primary: "'Inter', -apple-system, BlinkMacSystemFont, 'Segoe UI', 'Roboto', sans-serif",
    heading: "'Roboto Slab', 'Inter', sans-serif"
  },
  
  spacing: {
    xs: '0.5rem',    // 8px
    sm: '1rem',      // 16px
    md: '1.5rem',    // 24px
    lg: '2rem',      // 32px
    xl: '3rem',      // 48px
    xxl: '4rem',     // 64px
  },
  
  borderRadius: {
    sm: '0.375rem',  // 6px
    md: '0.5rem',    // 8px
    lg: '0.75rem',   // 12px
    xl: '1rem',      // 16px
    xxl: '1.25rem',  // 20px
    full: '9999px',
  },
  
  shadows: {
    sm: '0 1px 3px rgba(0, 0, 0, 0.1)',
    md: '0 4px 6px rgba(0, 0, 0, 0.1)',
    lg: '0 10px 20px rgba(0, 0, 0, 0.15)',
    xl: '0 20px 40px rgba(0, 0, 0, 0.2)',
  },
  
  transitions: {
    fast: '150ms ease-in-out',
    normal: '200ms ease-in-out',
    slow: '300ms ease-in-out',
  },
  
  breakpoints: {
    mobile: '480px',
    tablet: '768px',
    desktop: '1024px',
    wide: '1400px',
  },
};